export default function AuditReadyBanner() {
  return (
    <section className="bg-[#5B4CFF] py-8 lg:py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-center gap-5">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight" style={{ fontStyle: 'italic' }}>
          Audit <span className="font-bold">ready,</span> Always!
        </h2>
        <img src="/icon-audit-ready.svg" alt="Audit ready" className="w-14 h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20" />
      </div>
    </section>
  );
}
